import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// UserUsage
import UserUsage from '@/views/UserUsage'

const userUsage = [
  {
    path: "/UserUsage",
    element: <SandBox />,
    children: [
      {
        path: "index",
        element: docLazyFn(<UserUsage />),
      }
    ],
  }
];

export default userUsage;
